import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '/api/system/settings',
    name: 'systemSettingsGet',
    method: 'GET',
  });
  return [isRequestSuccessed, data || {}, exec];
});
